import { getRejectionErrorCodes, twilioErrorDocsUrl } from '../utils/twilioRejectionReasons';

/**
 * Twilio rejection reason with each error code linked to Twilio's reference
 * docs (CX-3086). Renders nothing when there is no reason and no code.
 */
export default function TwilioRejectionReason({ submission, title, className = '' }) {
  const reason = submission?.twilio_rejection_reason;
  const codes = getRejectionErrorCodes(submission);
  if (!reason && codes.length === 0) return null;

  return (
    <div className={`bg-red-50 border-l-4 border-red-400 p-3 rounded ${className}`}>
      {title && <p className="text-xs font-semibold text-red-900 mb-1">{title}</p>}
      {reason && (
        <p className="text-sm text-red-800 whitespace-pre-wrap">{reason}</p>
      )}
      {codes.length > 0 && (
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <span className="text-xs font-semibold text-red-900">
            Twilio error {codes.length > 1 ? 'codes' : 'code'}:
          </span>
          {codes.map((code) => (
            <a
              key={code}
              href={twilioErrorDocsUrl(code)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs font-mono bg-white border border-red-300 text-red-700 hover:text-red-900 hover:border-red-500 px-2 py-0.5 rounded underline"
              title={`View Twilio documentation for error ${code}`}
            >
              {code} ↗
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
